<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <breadcrumb :links="breadcrumb"></breadcrumb>
  <div class="page page-list">
    <div class="page-header p-3">
      <div class="header-control">
        <div>
          <h1 class="text-warning">Quản lí teams</h1>
        </div>
        <div>
          <button class="btn btn-sm btn-success mx-1" @click="openModalCreate()"><i class="fa fa-plus"></i> Tạo mới</button>
          <button class="btn btn-sm btn-danger" @click="onDelete()" :disabled="checkedlist.length == 0"><i
              class="fa fa-trash"></i> Xóa ({{ checkedlist.length }})</button>
        </div>
      </div>
    </div>
    <overlay class="page-body px-3" :loading="isSearching">
      <div class="table-responsive">
        <table class="table fixed-left fixed-right table-striped" v-if="result">
          <thead>
            <tr>
              <th>
                <div class="form-check" v-if="result.data.length">
                  <input class="form-check-input" type="checkbox" @click="checkall()"
                    :checked="checkedlist.length == result.data.length">
                </div>
              </th>
              <th>Tên</th>
              <th>Mã liên kết</th>
              <th class="action"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in result.data" :key="i">
              <td>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" @click="toggleCheckbox(item.id)"
                    :checked="checkedlist.includes(item.id)">
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.code }}</td>
              <td class="action">
                <a href="javascript: void(0)" @click="openModalUpdate(item)"><i class="fa fa-edit"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="py-2 px-3" v-if="result && result.data.length == 0">
          Không có dữ liệu
        </div>
      </div>
    </overlay>

    <div class="page-footer p-3">
      <div v-if="result">
        Hiển thị {{result.data.length}} ({{ result.from }} - {{ result.to }})/{{ result.total }}, Trang {{ result.current_page }}/{{ result.last_page }} | {{ checkedlist.length }} được chọn
      </div>
      <b-pagination :data="result" v-if="result" @change="onChangePage"></b-pagination>
    </div>
  </div>

  <b-modal ref="crudModal">
    <div class="modal-header">
      <h5 class="modal-title" v-if="this.crudForm.id"><i class="fa fa-edit"></i> Chỉnh sửa thông tin team</h5>
      <h5 class="modal-title" v-else><i class="fa fa-pencil"></i> Tạo mới team</h5>
      <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
    </div>

    <div class="modal-body">
      <div class="mb-3">
        <label>Tên</label>
        <input class="form-control" type="text" placeholder="Tên team" v-model="crudForm.name" :class="{ 'border-danger': crudForm.errors.name }"/>
        <div class="msg-error" v-if="crudForm.errors.name">{{ crudForm.errors.name[0] }}</div>
      </div>

      <div class="mb-3">
        <label>Mã liên kết</label>
        <input class="form-control" type="text" placeholder="Code liên kết tool domain" v-model="crudForm.code" :class="{ 'border-danger': crudForm.errors.code }"/>
        <div class="msg-error" v-if="crudForm.errors.code">{{ crudForm.errors.code[0] }}</div>
        
      </div>

      <div class="mb-3">
        <div class="des"><i class="bx bx-help-circle"></i> Mã liên kết tương ứng với username bên tool domain</div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-sm btn-secondary" @click="$refs.crudModal.hide()">Hủy</button>
      <button class="btn btn-sm btn-primary" @click="onSaveCrud()">Lưu</button>
    </div>
  </b-modal>
</template>